import { AsyncThunk } from '@reduxjs/toolkit';

import { withMandant } from '../../../../../shared/thunks/with-mandant/with-mandant.thunk';
import { Endpoints } from '../../../../shared/utils/endpoints-file.utils';

// TODO: UNCOMMENT CODE AND REPLACE MOCKED RESPONSE AFTER BE
export const getStatisticsTotalCount: AsyncThunk<
  number,
  number,
  Record<string, unknown>
> = withMandant<number, number>(
  Endpoints.GET_STATISTICS_TOTAL_COUNT,
  'statistics/get-statistics-total-count',

  async () =>
    /*{
  args, endpoint
    }*/
    {
      await new Promise<void>(resolve => setTimeout(resolve, 1000));
      // const queryParams = createQueryParams({
      //   appId: args,
      // });
      //
      // const { data }: AxiosResponse<number> = await axiosInstance.get(
      //   endpoint + queryParams
      // );

      return 61;
    }
);
